<script>
import ModelShow from '../models/show';

export default {
  extends: ModelShow,
  page: {
    title: "Detail Receipt Orders",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('receipt_orders.singular')) }},
    resourceRoute: {default: 'receipt_orders'},
    modelVariable: {default: 'receipt_order'},
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('receipt_orders.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('receipt_orders.plural')),
          href: "/receipt_orders",
        },
        {
          text: this.model && this.model.id ? this.model.order_id : this.$route.params.key,
          href: `/receipt_orders/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [{
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.delivery_order`)),
        value: this.model.delivery_order.order_id
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.customer`)),
        item: this.model.customer,
        value: {
          props: { item: { type: Object, default() { return {} } } },
          template: '<router-link :to="`/customers/${item.id}`">{{ lodash.get(item, "name") }}</router-link>'
        }
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.ordered_at`)),
        value: this.$moment.utc(this.model.ordered_at).local().format('DD MMMM YYYY')
      // }, {
      //   key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.due_at`)),
      //   value: this.$moment.utc(this.model.due_at).local().format('DD MMMM YYYY')
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.receipt_items`)),
        item: this.model.receipt_items,
        value: {
          props: { item: {type: Array, default() { return [] }} },
          computed: {
            fields() {
              return [
                { key: 'weight', label: this.lodash.upperFirst(this.$t('receipt_items.weight')), thClass: 'text-end', tdClass: 'text-end', formatter: (value) => this.$numeral(value).format('0,0.00') },
                { key: 'size', label: this.lodash.upperFirst(this.$t('receipt_items.size')), thClass: 'text-end', tdClass: 'text-end', formatter: (value) => this.$numeral(value).format('0,0.00') },
              ]
            }
          },
          template: `<b-table :fields="fields" :items="item" />`
        }
      // }, {
      //   key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.total`)),
      //   value: this.$numeral(this.model.total).format('0,0.00')
      }, {
        key: this.lodash.upperFirst(this.$t(`models.description`)),
        item: this.model.description,
        value: {
          props: { item: {type: String, default: ''} },
          template: `<span v-html="item || '-'"></span>`
        }
      }]
    }
  },
  methods: {
    getModelName() {
      return this.model['order_id'];
    },
    delete() {
      return this.$axios.delete(`/receipt_orders/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/receipt_orders/${this.$route.params.key}`, {
        params: {
          with: 'delivery_order,customer,trip.vehicle,receipt_items'

        }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    }
  }
}
</script>
